import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import IntlService from './IntlService';

/**
  A wrapper component that adds extra internationalization
  functionality to the IntlProvider component
  @property {defaultLocale}
  - **SHOULD NOT BE SET if you want user language options to persist on refresh**
  - otherwise you can force it to be one of the existing locales
  @property {messages}
  - an object pulled from translation json used to translate string literals in the app
*/

const SharedIntlContext = React.createContext();

export class SharedIntlProvider extends Component {
  constructor(props) {
    super(props);
    this.state = { locale: props.defaultLocale };
  }

  changeLocale = (newLocale) => {
    const { locale: curLocale } = this.state;
    if (newLocale !== curLocale) {
      IntlService.setLocale(newLocale);
      this.setState({
        locale: newLocale,
      });
    }
  }

  render() {
    const { children, messages } = this.props;
    const { locale } = this.state;
    return (
      <SharedIntlContext.Provider value={{ changeLocale: this.changeLocale }}>
        <IntlProvider locale={locale} messages={messages[locale]}>
          {children}
        </IntlProvider>
      </SharedIntlContext.Provider>
    );
  }
}

SharedIntlProvider.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
  messages: PropTypes.instanceOf(Object).isRequired,
  defaultLocale: PropTypes.string,
};

SharedIntlProvider.defaultProps = {
  defaultLocale: IntlService.getLocale(),
};

export const SharedIntlConsumer = SharedIntlContext.Consumer;
